
<div class="wrapper" [ngClass]="{ 'borderHover light-disabled-border-color hover-accent-border-color': border }" *ngIf="!loading">
  <a class="link-wrapper" [routerLink]="getRouterLink()" (click)="gaTrack()">

    <div class="product-list-item-image">
      <div class="hide" [ngClass]="productListItem.class" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()">
        <img [src]="productListItem.photo" [ngClass]="getClass()">
        <img *ngIf="productListItem.hoverPhoto" class="product-image fading" [src]="productListItem.hoverPhoto">
        <img *ngIf="productListItem.overlay" class="overlay" [src]="productListItem.overlay">
      </div>
    </div>

    <div class="name" *ngIf="border">
      <div class="artist-name">{{productListItem.artistName}}</div>
      <div class="product-name">{{productListItem.productName}}</div>
    </div>

    <div class="product-list-item-info" [ngClass]="{ 'disabled': productListItem.status == 'OUT', 'accent-background': productListItem.status != 'OUT' }">
      <span *ngIf="!bundle">{{ productListItem.types.join(' / ') }}</span>
      <span *ngIf="!bundle && productListItem.status == 'OUT'">OUT</span>
      <span *ngIf="bundle">Bundle</span>
      <span *ngIf="bundle">SAVE {{ productListItem.total_price | currency }}</span>
    </div>

  </a>
</div>

<div class="wrapper" [ngClass]="{ 'borderHover light-disabled-border-color hover-accent-border-color': border }" *ngIf="loading && account && account.loadingPhoto">
  <div class="product-list-item-image">
    <div class="hide black-background">
      <img [src]="account.loadingPhoto.medium_url">
    </div>
  </div>

  <div class="name" *ngIf="border">
    <div class="artist-name">Loading...</div>
    <div class="product-name">Loading...</div>
  </div>

  <div class="product-list-item-info accent-background">
    <span>Loading...</span>
  </div>
</div>